import { useState } from "react";
import { MdAdd } from "react-icons/md";
import NewArticle from "./NewArticle";
import NewGoodsReceived from "./NewGoodsReceived";
import "./ArticleManagement.scss";

export default function ArticleManagement() {
  const [isArticleModalOpen, setIsArticleModalOpen] = useState(false);
  const [isGoodsReceivedModalOpen, setIsGoodsReceivedModalOpen] = useState(false);

  return (
    <section className="sales-layout__page article-management">
      <h1>Artikelverwaltung</h1>
      <p>Hier werden zukünftig die Artikel verwaltet.</p>
      <div className="article-management__actions">
        <button
          type="button"
          className="article-management__btn-action"
          onClick={() => setIsArticleModalOpen(true)}
        >
          <MdAdd aria-hidden="true" /> Artikel
        </button>
        <button
          type="button"
          className="article-management__btn-action"
          onClick={() => setIsGoodsReceivedModalOpen(true)}
        >
          <MdAdd aria-hidden="true" /> Wareneingang
        </button>
      </div>

      {isArticleModalOpen && <NewArticle onClose={() => setIsArticleModalOpen(false)} />}
      {isGoodsReceivedModalOpen && (
        <NewGoodsReceived onClose={() => setIsGoodsReceivedModalOpen(false)} />
      )}
    </section>
  );
}
